import { IDeviceUpdateProviderService } from 'lavva.exalushome/build/js/Services/Updates/UpdateProviderServices/IDeviceUpdateProviderService';
import { ExtensionInfo } from 'lavva.exalushome/build/js/Services/Controller/ControllerExtensionsService';
import { Status } from 'lavva.exalushome/build/js/DataFrame';
import { IDevice } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { ResponseResult } from 'lavva.exalushome/build/js/Services/FieldChangeResult';
import { ICustomUpdateActions } from 'lavva.exalushome/build/js/Services/Updates/CustomUpdateActions/ICustomUpdateActions';
import { ProviderType, UpdateInfo } from 'lavva.exalushome/build/js/Services/Updates/IUpdatesProvider';
import { UpdateErrorCode, UpdateProgress, UpdateAction, BulkUpdateResult, BulkUpdateStatus, BulkUpdateDeviceStatus } from 'lavva.exalushome/build/js/Services/Updates/IUpdatesService';
import { PortosService } from '../../Portos';
import { SoftwareRuntimeInfo } from 'lavva.exalushome/build/js/Services/Updates/UpdatesProvider';
import { IDeviceUpdateInfo } from 'lavva.exalushome/build/js/Services/Updates/IUpdateInfo';

export class PortosDevicesUpdatesProvider implements IDeviceUpdateProviderService {

    public static readonly ProviderName = "PortosDeviceUpdateProvider";

    private _apiVersion: string;
    private _extenstionVersion: string;
    private _protocolExtGuid: string;
    private _runtimeInfo: SoftwareRuntimeInfo;

    constructor(extInfo: ExtensionInfo, runtimeInfo: SoftwareRuntimeInfo){
        this._apiVersion = extInfo.APIVersion;
        this._extenstionVersion = extInfo.ExtensionVersion;
        this._protocolExtGuid = extInfo.ExtensionGuid;
        this._runtimeInfo = runtimeInfo;
    }

    get ExtensionGuid(): string {
        return this._protocolExtGuid;
    }

    get ProtocolGuid(): string {
        return PortosService.PortosExtensionGuid;
    }

    get AvailableExtensionVersion(): string {
        return this._extenstionVersion;
    }

    get AvailableApiVersion(): string {
        return this._apiVersion;
    }

    get ProviderType(): ProviderType {
        return ProviderType.Device
    }

    GetUpdateProviderName(): string {
        return `${PortosDevicesUpdatesProvider.ProviderName}_${this._apiVersion}_${this._extenstionVersion}`;
    }

    GetAvailableUpdateAsync(device: IDevice): Promise<UpdateInfo | ResponseResult<UpdateErrorCode>> {
        throw new Error('Method not implemented.');
    }

    InstallUpdateAsync<T extends ICustomUpdateActions>(update: UpdateInfo, updateProgress: UpdateProgress, updateAction?: UpdateAction<T> | undefined): Promise<ResponseResult<UpdateErrorCode> | Status.OK> {
        throw new Error('Method not implemented.');
    }

    GetSoftwareVersionAsync(device: IDevice): Promise<string | ResponseResult<UpdateErrorCode>> {
        throw new Error('Method not implemented.');
    }

    async CheckUpdateBulkAsync(reloadCache?: boolean): Promise<UpdateInfo[] | ResponseResult<UpdateErrorCode>> {
        return [];
    }

    async InstalUpdateBulkAsync<T extends ICustomUpdateActions>(deviceGuids: string[], updateProgress: UpdateProgress, updateAction?: UpdateAction<T>): Promise<BulkUpdateResult | ResponseResult<UpdateErrorCode>> {
        throw new Error('Method not implemented.');
    }
}